import { gql } from "@apollo/client";
import { dateFormat, values } from "./helper";
export const typeDef = gql`
  type Campaign {
    id: ID
    name: String
    header: String
    description: String
    validityStartAt: String
    validityEndAt: String
    broadcastDiscount: Boolean
    discountApplyCount: Int
  }
`;
export const resolvers = {
  Campaign: {
    id: c => c.campaign_id,
    broadcastDiscount: c => {
      var _c$values;
      return c === null || c === void 0 || (_c$values = c.values) === null || _c$values === void 0 ? void 0 : _c$values.is_broadcast_discount;
    },
    validityStartAt: c => dateFormat(c.validity_start_at),
    validityEndAt: c => dateFormat(c.validity_end_at),
    discountApplyCount: c => values(c, "discount_apply_count")
  }
};